module.exports = __webpack_public_path__ + "assets/webgl/360_vignes.jpg.astc.2bd5a0ae.ktx";